import 'styles/components/generic/typeahead.less'
import TypeAheadInput, { SuggestionSource, TypeAheadInputOpts } from './TypeAheadInput'
import { get, post } from '../../tools/request'
import { Variable, all } from 'alkali'
import app from 'app/app'
import { remove as removeDiacritics } from 'diacritics'

interface PhraseInputOpts extends TypeAheadInputOpts<string> {
	termType?: string
}

interface AnnotatedPhrase {
	senses: string[]
	label: string
	title: string
	id?: string
	definition?: string
	unknown?: boolean
	downrank?: boolean
}

class PhraseSuggestionSource implements SuggestionSource<AnnotatedPhrase> {
	constructor(private readonly type: string, private readonly allowFreeText = true, private readonly freeTextWarning?) {}
	itemToText(item: AnnotatedPhrase) {
		return item.label
	}
	itemTitle(item: AnnotatedPhrase) {
		let title = this.itemToText(item)
		if (item.unknown || !item.senses?.length) {
			title = this.freeTextWarning ? `"${title}": ${this.freeTextWarning}` : item.definition
		} else if (item.senses?.length && app.user?.FeatureConfig?.Debug?.Enabled) {
			title += ' (' + item.senses.join(',') + ')'
		}
		return title
	}
	itemToEntry(item: AnnotatedPhrase) {
		item.title = this.itemTitle(item)
		let ids = item.ids || (item.id ? [ item.id ] : [])
		let senseIds = ids.filter(id => id.startsWith('S')).length
		let combinationIds = senseIds && ids.filter(id => id.startsWith('S') && id.includes('/')).length
		item.classes = {
			'unknown-text-suggestion': item.unknown,
			'literal-text-suggestion': senseIds == 0,
			'standard-term-suggestion': senseIds == 1 && !combinationIds,
			'multi-term-suggestion': senseIds == 1 && combinationIds > 0,
			'umbrella-term-suggestion': senseIds > 1,
			'loading-suggestion': item.loading,
		}
		return item
	}
	private lookupTerm(label: string): Promise<any> {
		if (!label) return Promise.resolve()
		return (this.lastSuggestions || (this.lastSuggestions = this.retrieveSuggestions(label)))
			.then(suggestions => suggestions?.[0])
		/*return ((label || '').length == 0) ? Promise.resolve(null) :
			post('/portal/phrase/bystring/search', {
				data: {
					query: label,
					type: this.type
				}
			}).catch(() => null)*/
	}
	findExact(value: string): Promise<AnnotatedPhrase> {
		return this.lookupTerm(value)
	}
	private retrieveSuggestions(query: string): Promise<any> {
		if (!(query || '').trim()) return Promise.resolve([])
		return this.lastSuggestions = get<any>('/portal/suggestions', {
			data: {
				search: query,
				type: this.type
			}
		}).then((suggestions = []) => suggestions.map(s => ({ ...s, senses: s.ids || s.id.split(',') })))
	}
	addDefaults(results, query) {
		results.push({ label: query, id: query, definition: 'Full text query for ' + query, unknown: true, fromText: true, downrank: true })
	}
	findMatches(query: string): Promise<AnnotatedPhrase[]> {
		return this.retrieveSuggestions(query).then((results = []) => {
			if (this.allowFreeText && !results.some(term => normalizeText(term.label) == normalizeText(query))) {
				this.addDefaults(results, query)
			}
			return results
		})
	}
}

export default class PhraseInput extends TypeAheadInput.with('.form-control', {
	onkeydown(event) {
		if (event.keyCode == 13) {
			setTimeout(() => {
				if (!this.valueVar.valueOf() && this.source.lastSuggestions) {
					this.source.lastSuggestions.then(suggestions => {
						this.updateValue(suggestions[0])
						$(this).typeahead('close')
					})

				}
			})
		}
		else {
			//null out valueVar
			this.updateValueOnly(null)
		}

	},
	onblur(event) {
		setTimeout(() => {
			var text = this.content.valueOf().toLowerCase().trim();
			if (!this.valueVar.valueOf() && this.source.lastSuggestions) {
				this.source.lastSuggestions.then(suggestions => {
					
					//if a match, auto-select it
					var found = suggestions.find(ls => ls.label.toLowerCase() == text);
					
					if (found)
						this.updateValue(found)
					$(this).typeahead('close')
				})

			}
		})
	},
}) {
	created(properties: PhraseInputOpts) {
		// caller should pass units as property
		const source = new PhraseSuggestionSource(properties.termType, properties.allowFreeText, properties.freeTextWarning)
		properties.source = source
		properties.valueVar || (properties.valueVar = new Variable())
		if (properties.title == undefined) {
			properties.title = all([properties.valueVar, properties.classes['invalid-field']], (item, invalid) =>  {

				if (invalid) {
					let msg = 'Please enter valid ' + (properties.placeholder || 'value') + '.'

					//add specific errors if they exist
					// if (Array.isArray(invalid)) {
					// 	const errMsg = invalid.join('\n')
					// 	if (errMsg) msg += '\n' + errMsg
					// }
					return msg
				}	
				else if (item)
					return source.itemTitle(item) 
				else 
					return `"${properties.content.valueOf()}"`

			})
		}
		super.created(properties)
	}
}
export function normalizeText(text) {
	return removeDiacritics(text.toLowerCase().replace(/[^\w\-]/g, ' ').replace(/s$/, ''))
}